<template>
  <b-card>
    <FormBuilder
      label="Kategori Pertanyaan"
      update
      :data="$store.state.questionCategory.detailData"
      :fields="fields"
      :loading-detail="$store.state.questionCategory.loadingDetail"
      :loading-submit="$store.state.questionCategory.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/question-category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('questionCategory/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('questionCategory/update', {
        id,
        data,
      })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('questionCategory/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
